module.exports = __webpack_public_path__ + "static/media/food-img.b5da4c7c.svg";